import { gql } from '@apollo/client';
import { PageRequestTypeInput } from 'graphql/types/settlement/CommonTypes';

export const GET_BLACKLISTED_DELIVERY_DRIVERS = gql`
    query GetBlacklistedDeliveryDrivers($pageRequest: PageRequestTypeInput) {
        getBlacklistedDeliveryDrivers(pageRequest: $pageRequest) {
            content {
                deliveryDriverId
                phone
                regionName
                warehouseName
                dspName
                banReason
                banTime
                banOperator
                banPeriod
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface BlacklistedDeliveryDriverType {
    deliveryDriverId: number;
    phone: number | null;
    regionName: string | null;
    warehouseName: string | null;
    dspName: string | null;
    banReason: number | null;
    banTime: string | null;
    banOperator: string | null;
    banPeriod: number | null;
}

export interface BlacklistedDeliveryDriverPageResponse {
    content: BlacklistedDeliveryDriverType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetBlacklistedDeliveryDriversResponse {
    getBlacklistedDeliveryDrivers: BlacklistedDeliveryDriverPageResponse;
}

export interface GetBlacklistedDeliveryDriversVariables {
    pageRequest?: PageRequestTypeInput | null;
}
